export default __webpack_public_path__ + "static/form-shapes-e4df8679ec91a8973775c691ff74cbca.png";